import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="entered"
export default class extends Controller {
  connect() {
    this.isSubmitting = false;
  }

  submitForm(event) {
    if (this.isSubmitting) {
      event.preventDefault();
      return;
    }

    this.isSubmitting = true;
    this.toggleRadioDisabled(true);
    this.element.requestSubmit();
  }

  enableForm() {
    this.isSubmitting = false;
    this.toggleRadioDisabled(false);
  }

  toggleRadioDisabled(disabled) {
    this.element.querySelectorAll("input[type='radio']").forEach((radioInput) => (radioInput.disabled = disabled));
  }
}
